<template>
    <v-card elevation="0">
        <v-card-actions class="ma-0 pa-0">
            <v-text-field hide-details type="number" v-model="_min[0]" outlined dense :rules="[rules.value]"></v-text-field>
            <v-card class="ma-1" elevation="0">.</v-card>
            <v-text-field hide-details type="number" v-model="_min[1]" outlined dense :rules="[rules.value]"></v-text-field>
            <v-card class="ma-1" elevation="0">.</v-card>
            <v-text-field hide-details type="number" v-model="_min[2]" outlined dense :rules="[rules.value]"></v-text-field>
            <v-card class="ma-1" elevation="0">-</v-card>
            <v-text-field hide-details type="number" v-model="_max[0]" outlined dense :rules="[rules.value]"></v-text-field>
            <v-card class="ma-1" elevation="0">.</v-card>
            <v-text-field hide-details type="number" v-model="_max[1]" outlined dense :rules="[rules.value]"></v-text-field>
            <v-card class="ma-1" elevation="0">.</v-card>
            <v-text-field hide-details type="number" v-model="_max[2]" outlined dense :rules="[rules.value]"></v-text-field>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "common-version-input",
    props:["min", "max"],
    data: () => ({
        _min:[],
        _max:[],
        rules: {
            value: value => Number(value) >= 0 || '> 0',
        },
    }),
    methods:{
        validate() {
            return [this._min.map(e=>Number(e) || 0), this._max.map(e=>Number(e) || 0)]
        }
    },
    created() {
        this._min = this.min
        this._max = this.max
    }
}
</script>

<style scoped>

</style>